// extracted by mini-css-extract-plugin
export default {"wrapper":"B0-z","play":"C0-z"};